import React from 'react';
import PaymentFailure from '../../../Components/UserComponents/PaymentFailed';

const PaymentFailedContainer = () => {
  return <PaymentFailure />;
};

export default PaymentFailedContainer;
